import { useEffect, useState } from "react";
import axios from "axios";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { Manifesto } from "@/components/Manifesto";
import { About } from "@/components/About";
import { Footer } from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/products`).then((r) => setProducts(r.data)).catch(() => {});

    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "success" && params.get("session_id")) {
      axios.post(`${API}/orders/verify`, { session_id: params.get("session_id") })
        .then(() => {
          // Clear URL params
          window.history.replaceState({}, document.title, window.location.pathname);
          // Optional: Show a success toast here if needed
          alert("¡Pago confirmado! Hemos enviado los detalles a tu correo.");
        })
        .catch(() => {});
    }
  }, []);

  return (
    <main className="bg-noir min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Catalog products={products} />
      <Manifesto />
      <About />
      <Footer />
    </main>
  );
}
